import React, { useState } from 'react';
import { LegalModal, type LegalDocType } from './LegalModal';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDocType | null>(null);
  return <>
      <footer className="bg-concrete-900 text-concrete-400 py-16 border-t border-concrete-800" data-id="element-156">
        <div className="container mx-auto px-4 text-center" data-id="element-157">
          <p className="mb-8 max-w-2xl mx-auto text-xs font-light leading-relaxed opacity-60" data-id="element-158">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
          <div className="flex justify-center gap-8 text-xs tracking-widest uppercase mb-8" data-id="element-159">
            <button type="button" onClick={() => setOpenDoc('terms')} className="hover:text-sand-50 transition-colors" data-id="element-160">
              Términos y Condiciones
            </button>
            <button type="button" onClick={() => setOpenDoc('privacy')} className="hover:text-sand-50 transition-colors" data-id="element-161">
              Políticas de Privacidad
            </button>
          </div>
          <p className="text-xs font-light" data-id="element-162">
            &copy; {new Date().getFullYear()} Arte en Cemento. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <LegalModal isOpen={openDoc !== null} type={openDoc ?? 'terms'} onClose={() => setOpenDoc(null)} data-id="element-163" />
    </>;
}